import excursionesDia from "../../../../assets/img/excursiones-dia.png";
import tourCompletos from "../../../../assets/img/tour-dia-completo.png";
import gastronomico from "../../../../assets/img/gastronomia.png";
import recorrido from "../../../../assets/img/recorrido-auto.png";
import aventura from "../../../../assets/img/aventura.png";
import toursPrivado from "../../../../assets/img/tour-turistico-privado.png";
import cataVino from "../../../../assets/img/cata-vino.png";
import tourPie from "../../../../assets/img/tours-pie.png";
import naturaleza from "../../../../assets/img/naturaleza.png";
import arqueologo from "../../../../assets/img/arqueologo.png";
import almuerzo from "../../../../assets/img/almuerzo.png";
import desayuno from "../../../../assets/img/desayuno.png";
import merienda from "../../../../assets/img/meriendas.png";
import bebidas from "../../../../assets/img/bebidas-sin-alcohol.png";
import traslados from "../../../../assets/img/traslados.png";
import guia from "../../../../assets/img/guia-turistico.png";
import cancelacion from "../../../../assets/img/cancelar-gratis.png";
import espanol from "../../../../assets/img/espanol.png";
import accesible from "../../../../assets/img/silla-de-ruedas.png";
import mascotas from "../../../../assets/img/pista.png";
import recogida from "../../../../assets/img/recorrido-auto.png";
import servicio from "../../../../assets/img/ayuda-seguridad.png";

const Actividad = ({ setForm, form }: any) => {
  const actividades = [
    {
      name: "Excursiones de día",
      icon: excursionesDia,
    },
    {
      name: "Tour días completos",
      icon: tourCompletos,
    },
    {
      name: "Tours gastronómicos",
      icon: gastronomico,
    },
    {
      name: "Recorridos en auto",
      icon: recorrido,
    },
    {
      name: "Tours turísticos",
      icon: tourCompletos,
    },
    {
      name: "Tours de aventura",
      icon: aventura,
    },
    {
      name: "Tours turisticos privados",
      icon: toursPrivado,
    },
    {
      name: "Tour de medio días",
      icon: tourCompletos,
    },
    {
      name: "Cata de vino",
      icon: cataVino,
    },
    {
      name: "Tours a pie",
      icon: tourPie,
    },
    {
      name: "Paseos por la naturaleza",
      icon: naturaleza,
    },
    {
      name: "Visitas arqueológicas",
      icon: arqueologo,
    },
  ];

  const actividadesAdicionales = [
    {
      name: "Almuerzo",
      icon: almuerzo,
    },
    {
      name: "Desayuno",
      icon: desayuno,
    },
    {
      name: "Merienda",
      icon: merienda,
    },
    {
      name: "Bebidas",
      icon: bebidas,
    },
    {
      name: "Traslados",
      icon: traslados,
    },
    {
      name: "Guía profesional",
      icon: guia,
    },
  ];

  const comodidades = [
    {
      name: "Cancelación gratis",
      icon: cancelacion,
    },
    {
      name: "Actividades en español",
      icon: espanol,
    },
    {
      name: "Accesible a sillas de ruedas",
      icon: accesible,
    },
    {
      name: "Admite mascotas",
      icon: mascotas,
    },
    {
      name: "Recogida en alojamiento",
      icon: recogida,
    },
    {
      name: "Servicio privado",
      icon: servicio,
    },
  ];

  const onClick = (e: any, value: string) => {
    switch (e.target.name) {
      case "activity":
        {
          // let input = form;
          let activities = form.ACTIVITIES;
          const activity = {
            id: "",
            //--'Wifi', 'Pileta', 'Televisor', 'Estacionamiento', 'Cocina', 'Refrigerador', 'Ropa de cama', 'Perchas', 'Espacio para guardar ropa',
            //--'Almuerzo', 'Desayuno', 'Merienda', 'Bebidas', 'Traslados', 'Guía profesional'
            name: value,
            excursion_id: "",
            created_at: "",
          };

          if (
            form.ACTIVITIES.filter((i: { name: string }) => i.name == value)
              .length > 0
          ) {
            activities = form.ACTIVITIES.filter(
              (i: { name: string }) => i.name != value
            );
          } else {
            activities.push(activity);
          }

          setForm({
            ...form,
            ACTIVITIES: activities,
          });
        }
        break;
      case "amenity":
        {
          // let input = form;
          let amenities = form.AMENITIES;
          const amenity = {
            id: "",
            //--'Wifi', 'Pileta', 'Televisor', 'Estacionamiento', 'Cocina', 'Refrigerador', 'Ropa de cama', 'Perchas', 'Espacio para guardar ropa',
            //--'Almuerzo', 'Desayuno', 'Merienda', 'Bebidas', 'Traslados', 'Guía profesional'
            name: value,
            excursion_id: "",
            created_at: "",
          };

          if (
            form.AMENITIES.filter((i: { name: string }) => i.name == value)
              .length > 0
          ) {
            amenities = form.AMENITIES.filter(
              (i: { name: string }) => i.name != value
            );
          } else {
            amenities.push(amenity);
          }

          setForm({
            ...form,
            AMENITIES: amenities,
          });
        }
        break;
      default:
        break;
    }
  };

  console.log(form);
  
  return (
    <div className="grid lg:grid-cols-1 gap-10 py-5 px-5">
      <div>
        <span className="font-bold text-black mb-2 block">
          ¿Qué tipo de actividad realizas?
        </span>
        <span></span>
        <div className="grid md:grid-cols-2 gap-5 mb-5">
          {actividades.map((t) => {
            if (
              form.ACTIVITIES.filter((i: { name: string }) => i.name == t.name)
                .length > 0
            ) {
              return (
                <label
                  className="inline-block border p-3 m-1 cursor-pointer text-black  opacity-1 border-black"
                  style={{ borderRadius: "20px" }}
                >
                  <span className="flex items-center">
                    <img src={t.icon} width={20} className="me-2" alt="" />
                    {t.name}
                  </span>
                  <button
                    className="hidden"
                    name="activity"
                    onClick={(e) => onClick(e, t.name)}
                  ></button>
                </label>
              );
            }

            return (
              <label
                className="inline-block border p-3 m-1 cursor-pointer text-black  opacity-1 border"
                style={{ borderRadius: "20px" }}
              >
                <span className="flex items-center">
                  <img src={t.icon} width={20} className="me-2" alt="" />
                  {t.name}
                </span>
                <button
                  className="hidden"
                  name="activity"
                  onClick={(event) => onClick(event, t.name)}
                ></button>
              </label>
            );
          })}
        </div>

        <span className="font-bold text-black mb-2 block">
          Servicios adicionales
        </span>
        <span></span>
        <div className="grid md:grid-cols-2 gap-5 mb-5">
          {actividadesAdicionales.map((t) => {
            if (
              form.ACTIVITIES.filter((i: { name: string }) => i.name == t.name)
                .length > 0
            ) {
              return (
                <label
                  className="inline-block border p-3 m-1 cursor-pointer text-black  opacity-1 border-black"
                  style={{ borderRadius: "20px" }}
                >
                  <span className="flex items-center">
                    <img src={t.icon} width={20} className="me-2" alt="" />
                    {t.name}
                  </span>
                  <button
                    className="hidden"
                    name="activity"
                    onClick={(e) => onClick(e, t.name)}
                  ></button>
                </label>
              );
            }

            return (
              <label
                className="inline-block border p-3 m-1 cursor-pointer text-black  opacity-1 border"
                style={{ borderRadius: "20px" }}
              >
                <span className="flex items-center">
                  <img src={t.icon} width={20} className="me-2" alt="" />
                  {t.name}
                </span>
                <button
                  className="hidden"
                  name="activity"
                  onClick={(event) => onClick(event, t.name)}
                ></button>
              </label>
            );
          })}
        </div>

        <span className="font-bold text-black mb-2 block">Comodidades</span>
        <span></span>
        <div className="grid md:grid-cols-2 gap-5 mb-5">
          {comodidades.map((t) => {
            if (
              form.AMENITIES.filter((i: { name: string }) => i.name == t.name)
                .length > 0
            ) {
              return (
                <label
                  className="inline-block border p-3 m-1 cursor-pointer text-black  opacity-1 border-black"
                  style={{ borderRadius: "20px" }}
                >
                  <span className="flex items-center">
                    <img src={t.icon} width={20} className="me-2" alt="" />
                    {t.name}
                  </span>
                  <button
                    className="hidden"
                    name="amenity"
                    onClick={(e) => onClick(e, t.name)}
                  ></button>
                </label>
              );
            }

            return (
              <label
                className="inline-block border p-3 m-1 cursor-pointer text-black  opacity-1 border"
                style={{ borderRadius: "20px" }}
              >
                <span className="flex items-center">
                  <img src={t.icon} width={20} className="me-2" alt="" />
                  {t.name}
                </span>
                <button
                  className="hidden"
                  name="amenity"
                  onClick={(event) => onClick(event, t.name)}
                ></button>
              </label>
            );
          })}
        </div>
      </div>
      <div></div>
    </div>
  );
};

export default Actividad;
